import { render, staticRenderFns } from "./generateRestrictions.vue?vue&type=template&id=10d2a131&"
import script from "./generateRestrictions.vue?vue&type=script&lang=js&"
export * from "./generateRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports